/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./view-html.component.scss.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./view-html.component";
import * as i3 from "@angular/platform-browser";
var styles_ViewHtmlComponent = [i0.styles];
var RenderType_ViewHtmlComponent = i1.ɵcrt({ encapsulation: 2, styles: styles_ViewHtmlComponent, data: {} });
export { RenderType_ViewHtmlComponent as RenderType_ViewHtmlComponent };
export function View_ViewHtmlComponent_0(_l) { return i1.ɵvid(2, [(_l()(), i1.ɵeld(0, 0, null, null, 0, "div", [["class", "html"]], [[8, "innerHTML", 1]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.safeHTML; _ck(_v, 0, 0, currVal_0); }); }
export function View_ViewHtmlComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-view-html", [], null, null, null, View_ViewHtmlComponent_0, RenderType_ViewHtmlComponent)), i1.ɵdid(1, 114688, null, 0, i2.ViewHtmlComponent, [i3.DomSanitizer], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ViewHtmlComponentNgFactory = i1.ɵccf("app-view-html", i2.ViewHtmlComponent, View_ViewHtmlComponent_Host_0, { html: "html" }, {}, []);
export { ViewHtmlComponentNgFactory as ViewHtmlComponentNgFactory };
